import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base-service';
import { DataSourcesRequestPost, DataSourcesResponse } from '../models';

@Injectable()
export class DataSourcesService extends BaseService {
    private readonly dataSourcesPath = '/data/data-sources';

    private getDataSourcesUrl(): string {
        return `${this.rootUrl}${this.dataSourcesPath}`;
    }

    getDataSources(body: DataSourcesRequestPost): Observable<DataSourcesResponse> {
        const url = this.getDataSourcesUrl();
        return this.http.post<DataSourcesResponse>(url, body);
    }
}
